import { render, staticRenderFns } from "./HomeTag.vue?vue&type=template&id=979ea540&scoped=true&"
import script from "./HomeTag.vue?vue&type=script&lang=js&"
export * from "./HomeTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979ea540",
  null
  
)

export default component.exports